const getterTypes = {
    GET_PRODUCTS: 'GET_PRODUCTS',
    GET_CATEGORIES: 'GET_CATEGORIES',
    GET_PRODUCT_CONFIG: 'GET_PRODUCT_CONFIG',
    GET_PRODUCT_CODE_CONFIG: 'GET_PRODUCT_CODE_CONFIG',
    GET_VARIANT: 'GET_VARIANT',
};

export { getterTypes };
